import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

const websiteDomain = process.env.NEXT_PUBLIC_SITEMAP_HOST;

export default function M({ langKey }: any) {
    const { useLang, Link, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang(langKey || 'poweroceancollection');
    const { locale } = router;

    const cards: any = [
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/13_1.jpg'),
            title: t('secM_card1_title'),
            desc: t('secM_card1_desc'),
            link: `${websiteDomain}/${locale}/powerstream`,
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/13_2.jpg'),
            title: t('secM_card2_title'),
            desc: t('secM_card2_desc'),
            link: `${websiteDomain}/${locale}/ecoflow-power-kits/series`,
        },
    ];

    return (
        <div className={`power-ocean-collection-M ${css['power-ocean-collection-M']}`}>
            <div className="card-box">
                {cards?.map((card: any, k: number) => (
                    <div key={k} className={`card card${k + 1}`}>
                        <div className="card-img">
                            <NextImage src={card?.img} alt={card?.title} aria-label={card?.title} />
                        </div>
                        <div className="card-text">
                            <p className="card-title">{card?.title}</p>
                            <p className="card-desc">{card?.desc}</p>
                            {/* <Link className="card-btn" href={card?.link}>
                                {t('secM_btn')}
                            </Link> */}
                            <a className="card-btn" href={card?.link} target="_blank" rel="noreferrer">
                                {t('secM_btn')}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
